module.exports = __webpack_public_path__ + "img/minus-stroke.08664cf6.svg";